import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getRegisteredQuestionCount } from '../../actions/Tickets/ticketsActions';
import Logo from '../../assets/svgs/Logo';
import Back from '../../assets/svgs/Back';

const PageHeader = ({
className, title, notAnsweredCount, useBack = false,
getRegisteredQuestionCount, loading, questionCounts,
}) => {

    useEffect(() => {
        if(questionCounts) {
            getRegisteredQuestionCount();
        }
    }, []);

    return (
        <div className={className}>
            <Link to="/dashboard">{useBack ? <Back/> : <Logo/>}</Link>
            <h2>{title} {questionCounts && <span className="number-badge">{loading ? 0 : notAnsweredCount}</span>}</h2>
        </div>
    );
};

PageHeader.defaultProps = {
    questionCounts: false,
};

PageHeader.propTypes = {
    className: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    questionCounts: PropTypes.bool,

};

const mapStateToProps = (state) => ({
    notAnsweredCount: state.tickets.notAnsweredCount,
    loading: state.tickets.loading
});

export default styled(
    connect(mapStateToProps, { getRegisteredQuestionCount })(PageHeader))`
    display: flex;
    justify-content: space-between;
    flex-flow: row-reverse;
    align-items: center;
    background: rgb(19, 189, 239);
    padding: 2em 2.0625em 1em 2.0625em;

    h2 {
        font-size: 1em;
        font-weight: 400;
        color: #fff;
        line-height: 28px;
        display: flex;
    }
    
    .number-badge {
        display: block;
        width: 24px;
        height: 24px;
        font-size: 14px;
        margin-right: 6px;
        background: #FFE0E0;
        border-radius: 50%;
        color: #CB0101;
        text-align: center;
    }
`;
